import { render, staticRenderFns } from "./ContactEditAwsDocuments.vue?vue&type=template&id=ad451d4e"
import script from "./ContactEditAwsDocuments.vue?vue&type=script&lang=ts"
export * from "./ContactEditAwsDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad451d4e')) {
      api.createRecord('ad451d4e', component.options)
    } else {
      api.reload('ad451d4e', component.options)
    }
    module.hot.accept("./ContactEditAwsDocuments.vue?vue&type=template&id=ad451d4e", function () {
      api.rerender('ad451d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactEditAwsDocuments.vue"
export default component.exports